import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

const AnalyticsRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}`;

    const sendCurrentPageView = () => {
      trackPageView(pagePath);
    };

    sendCurrentPageView();

    window.addEventListener(
      'mapapet-consent-change',
      sendCurrentPageView
    );

    return () => {
      window.removeEventListener(
        'mapapet-consent-change',
        sendCurrentPageView
      );
    };
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsRouteTracker;
